
import './App.css'; 
import 'devextreme/dist/css/dx.light.css'; 
import Container from '@mui/material/Container';

import Button from "@mui/material/Button";
import {variables } from './Variables.js';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SignInButton } from "./components/SignInButton";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig.js";
import { msalInstance } from "./index.js";
import Home from './Home.js'

var onetest = false

const lightTheme = createTheme({
    palette: {
        mode: 'light',
    },
});



function App() {
    const { instance, accounts } = useMsal();

    const trylogin = () => {
        if (onetest == false) {
            instance.acquireTokenSilent(loginRequest).catch(ex => {

                instance.loginRedirect(loginRequest).catch(e => {
                    console.log(e);
                });
            });
        }
    }

    const getUserName = () => {
        try {
            const account = msalInstance.getActiveAccount();

            return (<h4 className='username'>{account.username}</h4>);
        }
        catch (e) {
            
        }
    }
       
    return (
            <ThemeProvider theme={lightTheme}>
             <CssBaseline />
            {trylogin()} 
             <UnauthenticatedTemplate>
                <img src='img/Logo _viscaria.png' className='loggo' />
                    <SignInButton />
                </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                <img src='img/Logo _viscaria.png' className='loggo' />
                 {getUserName()}
                 <Home /></AuthenticatedTemplate>
            </ThemeProvider>

        );
      
    
        
    
}

export default App;
